import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { Store } from '@ngxs/store';
import { LoadFooterData, LoadHeaderData, LoadLanguages, LoadSponsors } from './application-state';
import { FooterComponent } from './components/footer/footer.component';
import { AnnouncementPopupComponent } from './components/announcement-popup/announcement-popup.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, AnnouncementPopupComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less'
})
export class AppComponent {
  title = 'De Nacht Van Vlaanderen';

   private readonly store = inject(Store);

  constructor() {
    console.log('Dispatching load actions for global data');
    this.store.dispatch([new LoadHeaderData(), new LoadFooterData(), new LoadSponsors(), new LoadLanguages()]);
  }
}
 